import { useEffect, useState } from "react";
import axiosInstance from "../../axiosInstance"; // Ensure this is correctly set up for API requests
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "./settings.css";
import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import { HeadingWrapper } from "../Atomics/SectionHeader/SectionHeader";

const Settings = () => {
    // State to store user data
    const [userData, setUserData] = useState({
        firstName: "N/A",
        lastName: "N/A",
        phoneNumber: "N/A",
        email: "N/A",
        carColor: "N/A",
        carNumber: "N/A",
        carModel: "N/A",
    });

    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    // Fetch user data when the component mounts
    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const token = localStorage.getItem("token"); 
                const response = await axiosInstance.get("/users/currentUser", {
                    headers: {
                        Authorization: token, 
                    },
                });

                if (response.status === 200 && response.data.success) {
                    const { firstName, lastName, phone, email, carColor, carNumber, carModel } = response.data.data.user;
                    setUserData({
                        firstName: firstName || "N/A",
                        lastName: lastName || "N/A",
                        phoneNumber: phone || "N/A",
                        email: email || "N/A",
                        carColor: carColor || "N/A",
                        carNumber: carNumber || "N/A",
                        carModel: carModel || "N/A",
                    });
                }
            } catch (error) {
                console.error("Error fetching user data:", error);
                setUserData((prevState) => ({
                    ...prevState,
                    firstName: "Error loading",
                    lastName: "Error loading",
                    phoneNumber: "Error loading",
                    email: "Error loading",
                    carColor: "Error loading",
                    carNumber: "Error loading",
                    carModel: "Error loading",
                }));
            }
        };

        fetchUserData();
    }, []);

    // Handle input change for editable fields
    const handleChange = (e) => {
        setUserData({ ...userData, [e.target.name]: e.target.value });
    };

    // Handle Save Changes (Update API)
    const handleSaveChanges = async () => {
        setLoading(true);
        setSuccessMessage("");
        setErrorMessage("");

        try {
            const token = localStorage.getItem("token"); 
            const response = await axiosInstance.put(
                "/users/updateUser",
                {
                    firstName: userData.firstName,
                    lastName: userData.lastName,
                    carColor: userData.carColor,
                    carNumber: userData.carNumber,
                    carModel: userData.carModel,
                },
                {
                    headers: {
                        Authorization: token, 
                    },
                }
            );

            if (response.status === 200) {
                setUserData((prevData) => ({
                    ...prevData,
                    firstName: response.data.firstName,
                    lastName: response.data.lastName,
                    carColor: response.data.carColor,
                    carNumber: response.data.carNumber,
                    carModel: response.data.carModel,
                }));
                setSuccessMessage("Profile updated successfully!");
            }
        } catch (error) {
            console.error("Error updating user data:", error);
            setErrorMessage("Failed to update profile. Please try again.");
        }

        setLoading(false);
    };

    return (
        <ContentWrapper>
            <Container fluid className="upload-details">
                <Row>
                    <Col>
                        <HeadingWrapper heading="Settings" />
                    </Col>
                </Row>
                <Form className="updt-frms">
                    <Row>
                        <Col md={6}>
                            <Form.Group controlId="first-name">
                                <Form.Label>First Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="firstName"
                                    value={userData.firstName}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="last-name">
                                <Form.Label>Last Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="lastName"
                                    value={userData.lastName}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <Form.Group controlId="phone-number">
                                <Form.Label>Phone Number</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={userData.phoneNumber}
                                    readOnly
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="email">
                                <Form.Label>Email Address</Form.Label>
                                <Form.Control
                                    type="email"
                                    value={userData.email}
                                    readOnly
                                    disabled
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {/* Car Details */}
                    <Row>
                        <Col md={6}>
                            <Form.Group controlId="car-color">
                                <Form.Label>Car Color</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="carColor"
                                    value={userData.carColor}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group controlId="car-number">
                                <Form.Label>Car Number</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="carNumber"
                                    value={userData.carNumber}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <Form.Group controlId="car-model">
                                <Form.Label>Car Model</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="carModel"
                                    value={userData.carModel}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {/* Success & Error Messages */}
                    {successMessage && <p className="text-success">{successMessage}</p>}
                    {errorMessage && <p className="text-danger">{errorMessage}</p>}

                    <Row>
                        <Col className="text-right">
                            <Button 
                                variant="success" 
                                className="updt_btn" 
                                onClick={handleSaveChanges}
                                disabled={loading}
                            >
                                {loading ? "Saving..." : "Save Changes"}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Container>

            <ThinFooter />
        </ContentWrapper>
    );
};

export default Settings;
